import {useEffect} from 'react';
import {getIsAiChatPremiumOnly} from '@Libraries/ai-chat.library';
import {useAppSelector} from '@/hooks';

export function useGetIsAiChatPremiumOnly(): boolean | null {
  const isPremiumOnly = useAppSelector((state) => {
    return state.aiChat.isPremiumOnly;
  });

  useEffect(() => {
    if (isPremiumOnly !== null) {
      return;
    }

    void getIsAiChatPremiumOnly();
  }, []);

  return isPremiumOnly;
}
